import "./style/PopOverMenuCanvas.scss";
import { createRef, PropsWithChildren, useCallback, useEffect } from "react";

type IProps = PropsWithChildren<{
  anchorEl: Element | null;
  onClose: () => void;
}>

export const PopOverMenuCanvas = ({ children, anchorEl, onClose }: IProps) => {
  const contentRef = createRef<HTMLDivElement>();

  const calcPosition = useCallback(() => {
    if (contentRef.current === null || anchorEl === null) {
      return;
    }

    const elementPos = anchorEl.getBoundingClientRect();
    const contentPos = contentRef.current.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    const pos = {
      top: elementPos.top - (contentPos.height / 2),
      left: elementPos.right,
    };

    if (pos.top + contentPos.height > windowHeight) {
      pos.top = elementPos.bottom - contentPos.height;
    }

    if (pos.top < 0) {
      pos.top = 16;
    }

    if (pos.left + contentPos.width > windowWidth) {
      pos.left = elementPos.left - contentPos.width;
    }

    if (pos.left < 0) {
      pos.left = 16;
    }

    contentRef.current.style.top = `${pos.top}px`;
    contentRef.current.style.left = `${pos.left}px`;
    contentRef.current.style.right = "auto";
    contentRef.current.style.bottom = "auto";
    contentRef.current.style.opacity = "1";
  }, [contentRef, anchorEl]);

  useEffect(() => {
    calcPosition();
    window.addEventListener("resize", calcPosition);

    return () => {
      window.removeEventListener("resize", calcPosition);
    };
  }, [calcPosition]);

  return (
    <div className="PopoverMenuCanvas">
      <div className="PopoverMenuCanvas-Backdrop" onClick={onClose}></div>
      <div className="PopoverMenuCanvas-Content" ref={contentRef} style={{ opacity: 0 }}>
        {children}
      </div>
    </div>
  );
};
